<template>
    <div>
        <div class="row" v-if="isInUse">
            <div class="alert alert-warning">
                La grille d'audit est déjà associée à {{ nbInstances }}  de formation.<br />Vous ne pouvez pas supprimer ou ajouter des critères et des questions, ni en modifier l'ordre. Les champs explications, la description des critères et les questions peuvent encore être reformulées.
            </div>
        </div>
        <div class="row" style="margin-top:1.5em">
            <div v-if="!currentTemplate.defaultTemplate" class="col-md-5">
                <div class="form-group">
                    <label>Intitulé thème :</label>
                    <typeahead
                    v-if="!isInUse && !isReady"
                    :placeholder="title"
                    :data="typeaheadData"
                    :template="typeaheadTemplate"
                    :on-hit="themeCallback"
                    v-model="typeaheadBuffer"
                    ></typeahead>
                    <span v-else v-text="title"></span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Nombre de patients :</label>
                    <input v-if="!isInUse && !isReady" class="form-control" type="number"
                    min="1" v-model="nbPatients"/>
                    <span v-else v-text="nbPatients"></span>
                </div>
            </div>
            <div v-if="!currentTemplate.defaultTemplate && !isInUse" class="col-md-3">
                <label> {{ !isReady ? 'Statut : En préparation' : 'Statut : ' }}</label>
                <div class="form-group">
                    <button v-if="!isReady" :disabled="!currentTemplate.targetId || !currentTemplate.criterias.length || (currentTemplate.satisfactionSurvey != 'NONE' && !currentTemplate.surveyQuestions.length)" class="btn btn-primary" @click="showPutOnlineModal = !showPutOnlineModal">Mettre en ligne</button>
                    <span v-else>En ligne</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <div class="form-group">
                    <label>Enquête de satisfaction :</label>
                    <dropdown v-if="!isInUse && !isReady" :text="surveyDropdownText" type="primary">
                        <li @click="changeSurveyStatus('OPTIONAL')" v-if="satisfactionSurveyStatus != 'OPTIONAL'"><a>Optionnel</a></li>
                        <li @click="changeSurveyStatus('REQUIRED')" v-if="satisfactionSurveyStatus != 'REQUIRED'"><a>Obligatoire</a></li>
                        <li @click="changeSurveyStatus('NONE')" v-if="satisfactionSurveyStatus != 'NONE'"><a>Désactivée</a></li>
                    </dropdown>
                    <span v-else v-text="surveyDropdownText"></span>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label>Explications grille d’audit tour 1 :</label>
            <quill-editor v-model="firstStepExplanation" @ready=""></quill-editor>
        </div>
        <div class="form-group">
            <label>Explications grille d’audit critique :</label>
            <quill-editor v-model="criticStepExplanation"@ready=""></quill-editor>
        </div>
        <div class="form-group">
            <label>Explications grille d’audit tour 2 :</label>
            <quill-editor v-model="secondStepExplanation"@ready=""></quill-editor>
        </div>
        <div class="form-group" v-if="!isInUse && !isReady && satisfactionSurveyStatus != 'NONE'">
            <div v-if="satisfactionSurveyStatus == 'NONE'" class="alert alert-warning">
                Attention ! L'enquête de satisfaction est actuellement désactivée.
            </div>
            <label>Explications enquête de satisfaction :</label>
            <quill-editor v-model="surveyExplanation"@ready=""></quill-editor>
        </div>
    
        <modal effect="fade" title="Mettre en ligne le modèle" :value="showPutOnlineModal" cancel-text="Annuler" ok-text="Mettre en ligne" @ok="putOnline()" @cancel="showPutOnlineModal = !showPutOnlineModal">
            <vAlert type="danger">
                {{ "Attention ! La mise en ligne de ce modèle de grille d'audit permettra sa distribution dans le cadre d'une formation sur le thème \"" + title + '".' }}
                <hr>
                La mise en ligne sera effective une fois que le modèle aura été sauvegardé.
            </vAlert>
        </modal>
    </div>
    <!-- <button @click="submitFormData()">Sauvegarder</button> -->
</template>


<script>
    import { quillEditor  as QuillEditor } from 'vue-quill-editor'
    import { dropdown as Dropdown, typeahead as Typeahead, modal as Modal, alert as VAlert } from 'vue-strap'
    
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    export default {
        components: {
            QuillEditor,
            Dropdown,
            Typeahead,
            Modal,
            VAlert
        },
        computed: {
            nbInstances: function()  {
                let cnt = this.currentTemplate.instances.length; 
                return cnt != 1 ? cnt + ' instances' : cnt + ' instance';
            },
            surveyDropdownText: function()  {
                if (this.satisfactionSurveyStatus == 'OPTIONAL')
                    return 'Optionnel';
                else if (this.satisfactionSurveyStatus == 'REQUIRED')
                    return 'Obligatoire';
                else if (this.satisfactionSurveyStatus == 'NONE')
                    return 'Désactivée';
            },
            title: {
                get() {
                    return this.currentTemplate.title;
                },
                set(value) {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'title', templateData: value});
                }
            },
            nbPatients: {
                get() {
                    return this.currentTemplate.nbPatients;
                },
                set(value) {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'nbPatients', templateData: value});
                }
            },
            firstStepExplanation: {
                get() {
                    return this.currentTemplate.explanations['FIRST_STEP'];
                },
                set(value) {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'explanations', key2: 'FIRST_STEP', templateData: value});
                }
            },
            criticStepExplanation: {
                get() {
                    return this.currentTemplate.explanations['CRITIC_STEP'];
                },
                set(value) {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'explanations', key2: 'CRITIC_STEP', templateData: value});
                }
            },
            secondStepExplanation: {
                get() {
                    return this.currentTemplate.explanations['SECOND_STEP'];
                },
                set(value) {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'explanations', key2: 'SECOND_STEP', templateData: value});
                }
            },
            surveyExplanation: {
                get() {
                    return this.currentTemplate.explanations['SATISFACTION_SURVEY'];
                },
                set(value) {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'explanations', key2: 'SATISFACTION_SURVEY', templateData: value});
                }
            },
            typeaheadData: function()   {
                return this.typeaheadDefaultData.filter(item => item.name.toLowerCase().includes(this.typeaheadBuffer));
            }
        },
        methods: { 
            changeSurveyStatus(newStatus)  {
                this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'satisfactionSurvey', templateData: newStatus});
            },
            themeCallback(item) {
                this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'title', templateData: item.name});
                this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'targetId', templateData: item.id});
                return item.name;
            },
            putOnline() {
                this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'isReady', templateData: true});
                this.showPutOnlineModal = !this.showPutOnlineModal;
            }
        },
        props: ['currentTemplate', 'isInUse', 'isReady', 'satisfactionSurveyStatus'],
        data: function()  {
            return {
                editorOption: {

                },
                typeaheadTemplate: "{{ item.name }}",
                showPutOnlineModal: false,
                typeaheadDefaultData: [],
                typeaheadBuffer: ""
            };
        },
        beforeCreate()  {
            let successCallback = (data) => {
                this.typeaheadDefaultData = data;
            };

            this.$store.dispatch('getTargetTemplates', {
                onlyEnabled: true,
                callbacks: {success: successCallback}
            });
        }
    };
</script>

<style>
    .ql-container .ql-editor {
        min-height: 20em;
        padding-bottom: 1em;
        max-height: 25em;
    }

    /* Enlarge typeahead dropdown for theme selection */
    .dropdown-menu {
        min-width: 600px;
        max-width: 800px;
    }

    .dropdown-menu > li > a {
        white-space: normal;
        word-wrap: break-word;
    }
</style>
